export default __webpack_public_path__ + "static/media/unassigned.7a5f1729.png";